<script>
  import { Popover } from '@sveltestrap/sveltestrap';

  import { Porthole } from '@client/components/porthole';
  import { Spinner } from '@client/components/spinner';

  import { PersonCell } from '@client/pages/insights/activity/cell-formatters';

  import { ReportsService } from '@client/services/reports';

  import { recipientsStore } from '@client/stores/recipients';

  import { generateUUID } from '@common/utils/strings';

  export let recipient;
  export let history;

  const fetchRecipientReport = async (email) => {
    const cachedRecipient = $recipientsStore[email];

    if (!cachedRecipient) {
      $recipientsStore[email] = {};
      const response = await ReportsService.getRecipientReport({ email });
      $recipientsStore[email] = response;

      return response;
    }

    return cachedRecipient;
  };
</script>

<div class="recipient">
  {#await fetchRecipientReport(recipient)}
    <Spinner inline show />
  {:then}
    <Porthole
      details={{
        photoUrl: $recipientsStore[recipient]?.person?.avatar || '',
        name: $recipientsStore[recipient]?.person?.name?.fullName || recipient,
        email: $recipientsStore[recipient]?.email || recipient
      }}
      size="small"
    />
    {#if $recipientsStore[recipient]?.person?.name?.fullName}
      {@const id = generateUUID()}
      <div class="recipient-name">
        <div>
          <span id="popover-{id}">{$recipientsStore[recipient].person.name.fullName}</span>
          <div class="email">{recipient}</div>
        </div>
        <Popover target="popover-{id}" class="recipient-popover" trigger="hover" position="right" title="">
          <PersonCell email={recipient} activity={Object.entries(history)} showCompanyLogo showExpanded />
        </Popover>
      </div>
    {:else}
      <div>{recipient}</div>
    {/if}
  {:catch}
    <Porthole
      details={{
        photoUrl: '',
        name: recipient,
        email: recipient
      }}
      size="small"
    />
    {recipient}
  {/await}
</div>

<style lang="scss" src="./recipient.scss"></style>
